import React from 'react'
import AnimateLine from '../../common/AnimateLine'
import EnterpriseFaqSection from "../../seo/EnterpriseFaqSection";
import PriceCardWrap from '../service/PriceCardWrap'
import AboutArea from './AboutArea'
import FeaturesArea from './FeaturesArea'
import HeroArea from './HeroArea'
import ServiceArea from './ServiceArea'
import { HOME_FAQ_ITEMS } from "../../../seo/seoConfig";

function HomePageOne() {
  return (
    <>
        <div className="creasoft-wrap">
            <AnimateLine/>
            <HeroArea/>
            <ServiceArea/>
            <AboutArea image="/img/logo-dark.svg"/>
            <FeaturesArea/>
            <PriceCardWrap/>
            <EnterpriseFaqSection
              id="home-faq"
              eyebrow="Preguntas frecuentes"
              title="Transparencia antes del primer kick-off"
              intro="Respuestas directas sobre cómo trabajamos con equipos enterprise, alcance en México e inteligencia artificial aplicada a tu stack actual."
              items={HOME_FAQ_ITEMS}
            />
        </div>
    </>
  )
}

export default HomePageOne